// extracted by mini-css-extract-plugin
module.exports = {"total":"style_total__2V0K8","statusDafault":"style_statusDafault__3qi7U","rejected":"style_rejected__LlCGz","pending":"style_pending__WDQbs"};